module.exports = __webpack_public_path__ + "static/media/tik-tok.216a56c0.svg";